import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { CardSwipeTray } from 'src/pages/CustomViews/custom-views-mobile-card-list/card-swipe-tray';
import { SwipeActionKind } from 'src/pages/CustomViews/custom-views-mobile-card-list/card-swipe.types';
import {
  CARD_SWIPE_ACTION_WIDTH_PX,
  SwipeRow,
} from 'src/pages/CustomViews/custom-views-mobile-card-list/mobile-card-list.elements';
import { useCardSwipe } from 'src/pages/CustomViews/custom-views-mobile-card-list/use-card-swipe';
import {
  SwipeableConversation,
  useConversationSwipeActions,
} from 'src/pages/CustomViews/custom-views-mobile-card-list/use-conversation-swipe-actions';

export const ConversationCardSwipe = ({
  conversation,
  isOpen,
  isSelectionMode,
  onOpenChange,
  onSwipeStart,
  renderCard,
}: {
  conversation: SwipeableConversation;
  isOpen: boolean;
  isSelectionMode: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onSwipeStart: () => void;
  renderCard: (isSwiping: () => boolean) => ReactNode;
}) => {
  const { isSwipeable, actions, runAction } = useConversationSwipeActions(conversation);
  const isEnabled = isSwipeable && !isSelectionMode;
  const isTrayOpen = isOpen && isEnabled;

  const swipe = useCardSwipe({
    isEnabled,
    isOpen: isTrayOpen,
    trayWidth: actions.length * CARD_SWIPE_ACTION_WIDTH_PX,
    onOpenChange,
    onSwipeStart,
  });

  const handleAction = (kind: SwipeActionKind) => {
    swipe.close();
    void runAction(kind);
  };

  return (
    <SwipeRow
      data-swipe-row={conversation.conversationId}
      data-testid={`custom-views-mobile-card-swipe-row-${conversation.conversationId}`}
    >
      {isEnabled ? (
        <CardSwipeTray
          width={swipe.trayVisibleWidth}
          actions={actions}
          isOpen={isTrayOpen}
          onAction={handleAction}
        />
      ) : null}
      <motion.div style={{ x: swipe.offset }} {...swipe.cardProps}>
        {renderCard(swipe.isSwiping)}
      </motion.div>
    </SwipeRow>
  );
};
